import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { PersonType } from 'src/app/services/models/enums';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { finalize, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';
import { LocalStorageService } from 'src/app/services/storage/local-storage.service';
import {
  AutocompleteConfig,
  SuggestionSearchInputComponent,
} from 'src/app/shared/components/suggestion-search-input/suggestion-search-input.component';
import { PageLoaderService } from 'src/app/services/page-loader.service';
import {
  WalletPaginationDto,
  WalletResponseDto,
  WalletService,
} from 'src/generated-sources/openapi/wallet-service/wallet';
import { WalletDataService } from 'src/app/services/data/wallet-data.service';
import { sortAlphabetically } from 'src/app/helpers/array-utils';
import { isAlert30DaysWallet } from 'src/app/helpers/plan-utils';
import { PortfolioManagerComponent } from 'src/app/components/entity-manager/portfolio-manager/portfolio-manager.component';
import { WalletAttributesAlertConfigDialogComponent } from 'src/app/components/wallet-alerts/wallet-attributes-alert-config-dialog/wallet-attributes-alert-config-dialog.component';
import {
  ConfirmationDialogComponent,
  ConfirmDialogResult,
  ConfirmDialogResultType,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { GenericTableComponent, TableCellDirective } from 'src/app/shared/components/generic-table';
import { getListGroupTableConfig, LIST_GROUP_NO_DATA_MESSAGE } from './list-group-table-config';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonComponent } from 'src/app/components/button/button.component';

@Component({
  selector: 'app-list-group',
  templateUrl: './list-group.component.html',
  styleUrls: ['./list-group.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatSelectModule,
    MatTooltipModule,
    SuggestionSearchInputComponent,
    ButtonComponent,
    GenericTableComponent,
    TableCellDirective,
  ],
})
export class ListGroupComponent implements OnInit, OnDestroy {
  STATES = {
    INITIAL: Symbol.for('INITIAL'),
    FIRST_LOAD: Symbol.for('FIRST_LOAD'),
    NO_RESULTS: Symbol.for('NO_RESULTS'),
    NO_MORE_RESULTS: Symbol.for('NO_MORE_RESULTS'),
    NEXT_LOAD: Symbol.for('NEXT_LOAD'),
    SHOWING: Symbol.for('SHOWING'),
    LOADING: Symbol.for('LOADING'),
    FINISHLOADING: Symbol.for('FINISH_LOADING'),
  };

  state = this.STATES.INITIAL;
  page: number = 0;
  pageSize: number = 10;

  @Output() modelSendToRedirect = new EventEmitter();
  @Output() modelSendReloadWallets = new EventEmitter();
  @Output() newWalletShortcutClick = new EventEmitter();
  @Output() walletTrendClick = new EventEmitter<WalletResponseDto>();

  @Input() showAdminActions: boolean = false;

  wallets: (WalletResponseDto & { isAlert30Days?: boolean })[] = [];
  enableEdit = true;
  selectedElement = null;
  newElement: boolean;
  modalInputsCustum;
  nameTemp: string;
  name = 'Angular';
  enableEditIndex = null;

  totalPage = 0;
  isLoading: boolean = false;

  tableConfig = getListGroupTableConfig();
  noDataMessage: string = LIST_GROUP_NO_DATA_MESSAGE;

  @ViewChild('name', { static: false }) nameField: ElementRef;
  @ViewChild('ITable', { static: false }) ITableRef: ElementRef;

  types: any[] = [$localize`Humana`, $localize`Empresa`];
  dataCL: boolean = false;
  tableHeadCartera = environment.tableHeadCartera;
  status: string;
  porfolioTable: any;
  pageSizeRecords: number = 10;
  totalPages: number = 0;
  failService: number = 0;
  loadingTable: boolean = true;
  searchedValue = '';

  personType = PersonType.COMPANY;
  autoCompleteConfig: AutocompleteConfig;
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly dialog: MatDialog,
    private readonly changeDetection: ChangeDetectorRef,
    private readonly walletService: WalletService,
    private readonly walletDataService: WalletDataService,
    private readonly _snackBar: MatSnackBar,
    private readonly pageLoaderService: PageLoaderService,
    private readonly localStorageService: LocalStorageService,
    public readonly globalService: GlobalServiceService,
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.globalService.getPersonType$().subscribe((type) => {
        this.personType = type;
        this.setWalletNames();
        this.reloadData();
      }),
    );

    this.subscriptions.push(
      this.walletDataService.getWallets$().subscribe(() => {
        this.setWalletNames();
      }),
    );

    this.subscriptions.push(
      this.globalService.getWalletAdded$().subscribe((type) => {
        this.reloadData();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  get userCountry() {
    return this.localStorageService.getItem('userCountry');
  }

  get urlAssets() {
    return this.localStorageService.getItem('urlAssets');
  }

  get inputSearchLabel() {
    return $localize`:@@label_enter_name:Ingresar nombre`;
  }

  getRemoveFavoriteTooltip(): string {
    return $localize`:@@removeFavorites:Eliminar de Favoritos`;
  }

  getAddFavoriteTooltip(): string {
    return $localize`:@@addFavorite:Agregar a Favoritos`;
  }

  setWalletNames() {
    const walletsNames = this.walletDataService.getWalletsValue().map((wallet) => wallet.name);
    this.autoCompleteConfig = { list: sortAlphabetically(walletsNames) };
  }

  onSearchInput(value: string) {
    this.searchedValue = value;
    this.reloadData();
  }

  reloadData() {
    this.state = this.STATES.INITIAL;
    this.changePage();
  }

  async reloadWallets() {
    this.modelSendReloadWallets.emit(null);
    if (this.wallets.length === this.pageSize) {
      this.state = this.STATES.NEXT_LOAD;
    } else {
      this.state = this.STATES.NO_MORE_RESULTS;
    }
  }

  handleEdit(wallet: WalletResponseDto) {
    if (this.isAlert30Days(wallet)) {
      return;
    }
    this.dialog.open(PortfolioManagerComponent, { data: wallet });
  }

  isAlert30Days(wallet: WalletResponseDto): boolean {
    const walletWithPlan = wallet as WalletResponseDto & { planId?: string };
    return isAlert30DaysWallet(walletWithPlan.planId);
  }

  handleDelete(wallet: WalletResponseDto) {
    const deleteWalletDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: $localize`:@@WalletDeletionTitle:Eliminación de cartera`,
        message: $localize`:@@ConfirmWalletDeletion:¿Confirmar la eliminación de la cartera ${wallet.name}?`,
        confirmButton: {
          text: $localize`:@@deleteWallet:Eliminar cartera`,
          style: 'danger',
          icon: 'delete_outlined',
        },
      },
    });
    deleteWalletDialogRef.afterClosed().subscribe(async (close: ConfirmDialogResultType) => {
      if (close === ConfirmDialogResult.Confirm) {
        this.delete(wallet);
      }
    });
  }

  delete(wallet: WalletResponseDto) {
    this.pageLoaderService.setPageLoader(true);
    this.walletService
      .deleteById({ id: wallet.id })
      .pipe(finalize(() => this.pageLoaderService.setPageLoader(false)))
      .subscribe({
        next: (response) => {
          this.reloadAfterDelete();
          this.modelSendReloadWallets.emit(wallet);
          this.openSnackBar(
            $localize`:@@wasDeletedCorrectly:Se eliminó correctamente: ${wallet.name}`,
          );
        },
        error: ({ error }) => {
          const defaultExclusionErrorMessage = $localize`:@@ErrorTryingToExclude:Error al intentar eliminar`;
          const responseErrorMessage = error?.errors?.[0]?.message ?? error?.message;
          this.openSnackBarError(responseErrorMessage ?? defaultExclusionErrorMessage);
        },
      });
  }

  reloadAfterDelete() {
    this.totalPage--;
    const isLastRegister = this.wallets.length === 1;
    const isNotFirstPage = this.page > 0;

    if (isLastRegister && isNotFirstPage) {
      this.changePage(this.page - 1);
    } else {
      this.changePage(this.page);
    }
  }

  toggleFavorite(wallet: WalletResponseDto) {
    this.pageLoaderService.setPageLoader(true);

    this.walletService
      .toggleFavorite({ id: wallet.id })
      .pipe(finalize(() => this.pageLoaderService.setPageLoader(false)))
      .subscribe({
        next: () => {
          wallet.favorite = !wallet.favorite;
        },
      });
  }

  manageAlerts(wallet: WalletResponseDto) {
    this.dialog.open(WalletAttributesAlertConfigDialogComponent, {
      data: wallet,
      width: '100%',
      maxWidth: '900px',
      height: '700px',
    });
  }

  async sendInfoRedirect(wallet: WalletResponseDto) {
    this.modelSendToRedirect.emit(wallet);
  }

  changePage(page: number = 0) {
    this.page = page;
    this.loadMoreData();
    this.changeDetection.detectChanges();
  }

  loadMoreData() {
    this.state = this.STATES.INITIAL;
    this.isLoading = true;

    const { page, pageSize, searchedValue } = this;

    this.walletService.listPageable({ search: searchedValue, page, perPage: pageSize }).subscribe({
      next: (response: WalletPaginationDto) => {
        this.wallets = response.items.map((wallet) => ({
          ...wallet,
          isAlert30Days: this.isAlert30Days(wallet),
        }));
        this.totalPage = response.total;
        this.isLoading = false;

        if (!this.wallets.length) {
          this.state = this.STATES.NO_RESULTS;
        } else {
          this.state = this.STATES.SHOWING;
        }
      },
      error: (error) => {
        this.state = this.STATES.NO_RESULTS;
        this.wallets = [];
        this.openSnackBarError(
          $localize`:@@js_getPortfolioListError:Error al intentar obtener lista de portfolios`,
        );
        this.isLoading = false;
      },
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, $localize`:@@js_Close:Cerrar`, {
      duration: 7000,
      panelClass: ['snackbar-fail'],
    });
  }

  openSnackBar(message: string) {
    if (this._snackBar) {
      this._snackBar.open(message, $localize`:@@js_Close:Cerrar`, {
        duration: 6000,
      });
    }
  }

  handleNewWalletShortcutClick() {
    this.newWalletShortcutClick.emit();
  }

  openWalletTrend(wallet: WalletResponseDto): void {
    this.walletTrendClick.emit(wallet);
  }
}
